































































































































import { Component, Vue } from 'vue-property-decorator';
import {
  FilterDTO, CatalogItemFullDTOTypeEnum,
  SupplierDTO, CatalogItemShortDTO,
} from '@/api';
import EditingLayout from '@/layouts/EditingLayout.vue';
import Upload from '@/components/common/Upload.vue';
import CardForm from '@/components/common/CardForm.vue';
import { clientsModule } from '@/store';
import services from '@/services';
import { Form } from 'element-ui';
import {
  filterObject, fileReader, getAuthToken, throwError, getAssetUrl,
} from '@/utils';
import axios from 'axios';
import CatalogItemPrice from '@/components/CatalogItemPrice.vue';
// import { fileToBase64 } from 'ts-image-processor';
import ThingForm from './ThingForm.vue';

interface IForm {
  name: string;
  type: CatalogItemFullDTOTypeEnum | undefined;
  brandId: string | undefined;
  categoryId: number | undefined;
  colorId: string | undefined;
  supplierId: string | undefined;
  size: string | undefined;
  price: number | undefined;
  priceDiscount: number | undefined;
  thingUrl: string | undefined;
  temperatureFrom: string | undefined;
  temperatureTo: string | undefined;
}

interface IThingItem {
  imgUrl: string | null;
  file?: File | undefined;
  catalogItemId?: number;
  form: IForm;
}

@Component({
  name: 'add-thing-page',
  components: {
    EditingLayout,
    ThingForm,
    Upload,
    CardForm,
    CatalogItemPrice,
  },
})
export default class AddThings extends Vue {
  loading = false;

  things: IThingItem[] = [];

  groupEditing = false;

  categories: FilterDTO[] = [];

  brands: FilterDTO[] = [];

  colors: FilterDTO[] = [];

  genders: FilterDTO[] = [];

  suppliers: SupplierDTO[] = [];

  items: CatalogItemShortDTO[] = [];

  selectedItems: number[] = [];

  get thingTypes() {
    return Object.values(CatalogItemFullDTOTypeEnum);
  }

  get client() {
    return clientsModule.model;
  }

  common: IForm = {
    name: '',
    type: CatalogItemFullDTOTypeEnum.CLOTHES,
    brandId: undefined,
    categoryId: undefined,
    colorId: '90',
    supplierId: undefined,
    size: '',
    price: undefined,
    priceDiscount: undefined,
    thingUrl: undefined,
    temperatureFrom: undefined,
    temperatureTo: undefined,
  }

  async created() {
    if (this.client && this.client.id != null) {
      const { data: categories } = await services.catalogService()
        .catalogEndpointGetClientCategoryNames(this.client.id);
      this.categories = categories;
    }
    const { data: brands } = await services.catalogService().catalogEndpointGetFilterNames('BRAND');
    const { data: colors } = await services.catalogService().catalogEndpointGetFilterNames('COLOR');
    const { data: suppliers } = await services.catalogService().catalogEndpointGetSuppliersList();
    this.brands = brands;
    this.colors = colors;
    this.suppliers = suppliers;
  }

  async onFiles(files: File[]) {
    const urls = await this.uploadImage(files);
    const things: IThingItem[] = await Promise.all(urls.map(async url => ({
      // imgUrl: await fileToBase64(file),
      // file,
      imgUrl: url,
      catalogItemId: undefined,
      form: {
        name: '',
        type: undefined,
        brandId: undefined,
        categoryId: undefined,
        colorId: '90',
        supplierId: undefined,
        size: '',
        price: undefined,
        priceDiscount: undefined,
        thingUrl: '',
        temperatureFrom: undefined,
        temperatureTo: undefined,
      },
    })));
    this.things.push(...things);
  }

  addThing() {
    this.things.push({
      imgUrl: null,
      catalogItemId: undefined,
      file: undefined,
      form: {
        name: '',
        type: undefined,
        brandId: undefined,
        categoryId: undefined,
        colorId: '90',
        supplierId: undefined,
        size: '',
        price: undefined,
        priceDiscount: undefined,
        temperatureFrom: undefined,
        temperatureTo: undefined,
        thingUrl: '',
      },
    });
  }

  updateForm<K extends keyof IForm>(index: number, propertyName: K, value: IForm[K]) {
    this.things[index].form[propertyName] = value;
  }

  onDelete(index: number) {
    this.things.splice(index, 1);
  }

  onCopy(index: number, item: IThingItem) {
    this.things.splice(index, 0, { ...item, form: { ...item.form } });
  }

  onImprove(index: number, url: string | null) {
    this.things[index].imgUrl = url;
  }

  async onFile(index: number, file: File) {
    // this.things[index].imgUrl = await fileToBase64(file);
    // this.things[index].file = file;
    const [url] = await this.uploadImage([file]);
    this.things[index].imgUrl = url;
  }

  setCommon() {
    const common = filterObject(this.common);
    this.things.forEach((_, index) => {
      this.$set(this.things[index], 'form', Object.assign(this.things[index].form, common));
    });
  }

  addSupplier(item: SupplierDTO) {
    this.suppliers.push(item);
  }

  addBrand(item: FilterDTO) {
    this.brands.push(item);
  }

  async uploadImage(files: File[]) {
    const urls = await Promise.all(files.map(async file => fileReader(file)
      .then(binary => axios.post<string>(`https://rest.styleconcierge.ru/api/story/uploadBackground/${file.name}`, binary, {
        headers: { 'Content-Type': 'application/octet-stream', Authorization: `Bearer ${getAuthToken()}` },
      })
        .catch((e) => {
          throwError('Ошибка загрузки изображений');
          this.loading = false;
          throw new Error(e);
        }))));
    return urls.map(u => u.data);
  }

  async onSubmit() {
    this.loading = true;
    const forms: Form[] = Array.isArray(this.$refs.forms)
      ? (this.$refs.forms as any).map((form: any) => form.$refs.form)
      : [];
    const validatorsResult = await Promise.all(forms.map(async (form) => {
      try {
        const result = await form.validate();
        return result;
      } catch (e) {
        return false;
      }
    }));

    if (validatorsResult.every(f => f)) {
      try {
        const t = this.things.map(async ({
          form, catalogItemId, file, imgUrl,
        }, index) => {
          const compilationId = Number(this.$route.params.compilationId);
          try {
            if (catalogItemId) {
              await services.compilationsApi()
                .compilationEndpointAddThingToCompilation(compilationId, catalogItemId);
            } else {
              await services.compilationsApi()
                .compilationEndpointUploadThing(
                  undefined,
                  compilationId,
                  form.thingUrl,
                  'CLOTHES',
                  '',
                  String(form.brandId),
                  String(form.supplierId),
                  46,
                  form.size as string,
                  form.price,
                  form.priceDiscount,
                  form.categoryId as number,
                  form.temperatureFrom,
                  form.temperatureTo,
                  imgUrl || undefined,
                  file?.name,
                  file,
                );
            }
            return index;
          } catch (e) {
            throw e;
          }
        });
        const results = await Promise.allSettled(t);
        // @ts-ignore
        const fulfilledIndexes: number[] = results.filter(result => result.status === 'fulfilled').map(result => result.value);
        // @ts-ignore
        const rejected = results.filter(result => result.status === 'rejected').map(result => result.reason.message);
        this.things = this.things.filter((_, index) => !fulfilledIndexes.includes(index));
        if (rejected.length > 0) {
          throw rejected;
        }
        this.$message({
          type: 'success',
          message: `Вещь: ${fulfilledIndexes.map(i => i + 1).join(', ')} успешно сохранена`,
        });
        this.$router.push({ name: 'compilation-things' });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        this.$notify({ title: 'Ошибка!', message: error, type: 'error' });
      } finally {
        this.loading = false;
      }
    }
    this.loading = false;
    return null;
  }

  onCatalogItem(index: number, item: CatalogItemShortDTO) {
    if (item) {
      // const brand = this.brands.find(b => b.name === item.brandName);
      this.things[index].catalogItemId = item.id;
      this.things[index].imgUrl = this.getImgUrl(item.pictUrl);
    // this.things[index].form.name = item.name;
    // this.things[index].form.brandId = brand?.id;
    // this.things[index].form.priceDiscount = item.priceDiscount;
    // this.things[index].form.size = (item.prices || [])[0].size || '';
    // this.things[index].form.price = (item.prices || [])[0].price || 0;
    // this.things[index].form.priceDiscount = item.priceDiscount;
    } else {
      this.things[index].catalogItemId = undefined;
      this.things[index].imgUrl = null;
    }
  }

  back() {
    this.$router.push({ name: 'compilation-things' });
  }

  getImgUrl(path: string) {
    return getAssetUrl(path);
  }
}
